const foodData = [
  {
    food: "M&M’s العادي",
    type: "وجبات خفيفة",
    serving: "كيس",
    size: 1,
    weight: 48,
    protein: 3.02,
    fat: 10.66,
    carbohydrates: 32.74,
    calories: 228.48,
    sugar: null,
  },
  {
    food: "أرز ( مطبوخ )",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 158,
    protein: 4.25,
    fat: 0.44,
    carbohydrates: 44.51,
    calories: 205.4,
    sugar: null,
  },
  {
    food: "أفوكادو",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 146,
    protein: 2.9,
    fat: 21.4,
    carbohydrates: 12.5,
    calories: 233.6,
    sugar: 1,
  },
  {
    food: "إلبة",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 4.3,
    fat: 3.3,
    carbohydrates: 17.8,
    calories: 118,
    sugar: null,
  },
  {
    food: "آلو",
    type: "أكلات شعبية",
    serving: "3 حبات",
    size: 3,
    weight: 100,
    protein: 2.63,
    fat: 4.86,
    carbohydrates: 20.6,
    calories: 136,
    sugar: null,
  },
  {
    food: "أناناس",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 155,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 20.3,
    calories: 77.5,
    sugar: 14.4,
  },
  {
    food: "أناناس معلب",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 255,
    protein: 0.89,
    fat: 0.28,
    carbohydrates: 51.51,
    calories: 198.9,
    sugar: null,
  },
  {
    food: "أومليت",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 61,
    protein: 6.5,
    fat: 7.3,
    carbohydrates: 0.4,
    calories: 95.8,
    sugar: 0.4,
  },
  {
    food: "آيس كريم بالفانيلا",
    type: "وجبات خفيفة",
    serving: "نصف كوب",
    size: 0.5,
    weight: 90,
    protein: 4.62,
    fat: 14.52,
    carbohydrates: 31.15,
    calories: 265.32,
    sugar: null,
  },
  {
    food: "آيس كريم بالفراولة",
    type: "وجبات خفيفة",
    serving: "نصف كوب",
    size: 0.5,
    weight: 90,
    protein: 4.22,
    fat: 11.09,
    carbohydrates: 36.43,
    calories: 253.44,
    sugar: null,
  },
  {
    food: "آيس كريم شكولاتة",
    type: "وجبات خفيفة",
    serving: "نصف كوب",
    size: 0.5,
    weight: 91,
    protein: 4.2,
    fat: 14.9,
    carbohydrates: 20.2,
    calories: 232,
    sugar: null,
  },
  {
    food: "آيسكريم سندويش",
    type: "وجبات خفيفة",
    serving: "قطعة",
    size: 1,
    weight: 63,
    protein: 3,
    fat: 6,
    carbohydrates: 27,
    calories: 170,
    sugar: null,
  },
  {
    food: "البازلا الخضراء",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 160,
    protein: 8.6,
    fat: 0.4,
    carbohydrates: 25,
    calories: 134.4,
    sugar: 9.5,
  },
  {
    food: "البرتقال",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 131,
    protein: 1.2,
    fat: 0.2,
    carbohydrates: 15.4,
    calories: 61.6,
    sugar: 12.2,
  },
  {
    food: "البطاطا الحلوة",
    type: "خضروات",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 130,
    protein: 2,
    fat: 0.1,
    carbohydrates: 26.2,
    calories: 111.8,
    sugar: 5.4,
  },
  {
    food: "البقدونس",
    type: "خضروات",
    serving: "10 أغصان",
    size: 10,
    weight: 10,
    protein: 0.3,
    fat: 0.1,
    carbohydrates: 0.6,
    calories: 3.6,
    sugar: 0.1,
  },
  {
    food: "الترمس",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 166,
    protein: 25.8,
    fat: 4.8,
    carbohydrates: 16.4,
    calories: 197.5,
    sugar: null,
  },
  {
    food: "التمر",
    type: "فواكه",
    serving: "4 حبات",
    size: 4,
    weight: 32,
    protein: 0.8,
    fat: 0.1,
    carbohydrates: 24,
    calories: 90.2,
    sugar: 20.3,
  },
  {
    food: "التوت الأزرق",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 145,
    protein: 1.1,
    fat: 0.5,
    carbohydrates: 21,
    calories: 82.6,
    sugar: 14.4,
  },
  {
    food: "التوت الأسود",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 144,
    protein: 2,
    fat: 0.7,
    carbohydrates: 13.8,
    calories: 61.9,
    sugar: 7,
  },
  {
    food: "التوت البري",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 95,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 11.6,
    calories: 43.7,
    sugar: 3.8,
  },
  {
    food: "التين",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 50,
    protein: 0.4,
    fat: 0.2,
    carbohydrates: 9.6,
    calories: 37,
    sugar: 8.1,
  },
  {
    food: "الجرجير",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 34,
    protein: 0.8,
    fat: null,
    carbohydrates: 0.4,
    calories: 3.7,
    sugar: 0.1,
  },
  {
    food: "الخوخ",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 150,
    protein: 1.4,
    fat: 0.4,
    carbohydrates: 14.3,
    calories: 58.5,
    sugar: 12.6,
  },
  {
    food: "الخوخ المجفف",
    type: "فواكه",
    serving: "كوب(أنصاف)",
    size: 0.5,
    weight: 160,
    protein: 5.8,
    fat: 1.2,
    carbohydrates: 98.1,
    calories: 382.4,
    sugar: 66.8,
  },
  {
    food: "الرجلة",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 43,
    protein: 0.6,
    fat: null,
    carbohydrates: 1.5,
    calories: 6.9,
    sugar: null,
  },
  {
    food: "السبانخ",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 30,
    protein: 0.9,
    fat: 0.1,
    carbohydrates: 1.1,
    calories: 6.9,
    sugar: 0.1,
  },
  {
    food: "الشمام",
    type: "فواكه",
    serving: "كوب(قطع)",
    size: 1,
    weight: 177,
    protein: 1.5,
    fat: 0.3,
    carbohydrates: 14.4,
    calories: 60.2,
    sugar: 13.9,
  },
  {
    food: "الفاصوليا السوداء",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 164,
    protein: 14.5,
    fat: 4.2,
    carbohydrates: 45,
    calories: 269,
    sugar: 7.9,
  },
  {
    food: "الفاصولياء",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 177,
    protein: 15.3,
    fat: 0.9,
    carbohydrates: 40.4,
    calories: 224.8,
    sugar: 0.6,
  },
  {
    food: "الفاصولياء الخضراء",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 110,
    protein: 2,
    fat: 0.1,
    carbohydrates: 7.8,
    calories: 34.1,
    sugar: 1.5,
  },
  {
    food: "الفجل الأحمر",
    type: "خضروات",
    serving: "شرائح(نصف كوب)",
    size: 0.5,
    weight: 58,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 2,
    calories: 9.3,
    sugar: 1.2,
  },
  {
    food: "القرنبيط",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 100,
    protein: 2,
    fat: 0.1,
    carbohydrates: 5.3,
    calories: 25,
    sugar: 2.4,
  },
  {
    food: "الكراث (البقل)",
    type: "خضروات",
    serving: "4 ملاعق صغيرة",
    size: 4,
    weight: 40,
    protein: 1,
    fat: null,
    carbohydrates: 6.7,
    calories: 28.8,
    sugar: null,
  },
  {
    food: "الكرز الحامض",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 103,
    protein: 1,
    fat: 0.3,
    carbohydrates: 12.5,
    calories: 51.5,
    sugar: 8.7,
  },
  {
    food: "الكرز الحلو",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 117,
    protein: 1.2,
    fat: 0.2,
    carbohydrates: 18.7,
    calories: 73.7,
    sugar: 15,
  },
  {
    food: "الكزبرة",
    type: "خضروات",
    serving: "9 أغصان",
    size: 9,
    weight: 20,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 0.7,
    calories: 4.6,
    sugar: 0.2,
  },
  {
    food: "اللفت",
    type: "خضروات",
    serving: "كوب مقطع شرائح",
    size: 1,
    weight: 67,
    protein: 2.2,
    fat: 0.5,
    carbohydrates: 6.7,
    calories: 33.5,
    sugar: null,
  },
  {
    food: "اموش",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 6.84,
    fat: 1.7,
    carbohydrates: 26.81,
    calories: 149.9,
    sugar: null,
  },
  {
    food: "باباي",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 304,
    protein: 1.9,
    fat: 0.4,
    carbohydrates: 29.8,
    calories: 118.6,
    sugar: 17.9,
  },
  {
    food: "باجلة",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 6.2,
    fat: 1,
    carbohydrates: 16.3,
    calories: 99,
    sugar: null,
  },
  {
    food: "باذنجان",
    type: "خضروات",
    serving: "نصف كوب",
    size: 0.5,
    weight: 82,
    protein: 0.84,
    fat: 0.15,
    carbohydrates: 4.98,
    calories: 21.32,
    sugar: null,
  },
  {
    food: "بازلاء مثلجة",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 63,
    protein: 1.8,
    fat: 0.1,
    carbohydrates: 4.8,
    calories: 26.5,
    sugar: 2.5,
  },
  {
    food: "بالبندق M&M’s",
    type: "وجبات خفيفة",
    serving: "كيس واحد",
    size: 1,
    weight: 49,
    protein: 5.24,
    fat: 13.18,
    carbohydrates: 28.91,
    calories: 242.55,
    sugar: null,
  },
  {
    food: "بامية",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 100,
    protein: 2,
    fat: 0.1,
    carbohydrates: 7,
    calories: 31,
    sugar: 1.2,
  },
  {
    food: "بثيث",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 2.6,
    fat: 6.4,
    carbohydrates: 71,
    calories: 352,
    sugar: null,
  },
  {
    food: "بخاري دجاج",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 18.6,
    fat: 2.8,
    carbohydrates: 17.4,
    calories: 169,
    sugar: null,
  },
  {
    food: "بخاري لحم",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 22.49,
    fat: 1.32,
    carbohydrates: 7.83,
    calories: 133,
    sugar: null,
  },
  {
    food: "بخصم",
    type: "خبز وحبوب",
    serving: "قطعة",
    size: 1,
    weight: 10,
    protein: 1.2,
    fat: 0.95,
    carbohydrates: 6.84,
    calories: 41.2,
    sugar: null,
  },
  {
    food: "برجر الدجاج",
    type: "أكلات شعبية",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 100,
    protein: 8.5,
    fat: 2.8,
    carbohydrates: 33.4,
    calories: 193,
    sugar: null,
  },
  {
    food: "برجر اللحم",
    type: "أكلات شعبية",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 100,
    protein: 10,
    fat: 4.3,
    carbohydrates: 33.3,
    calories: 176.2,
    sugar: null,
  },
  {
    food: "برنجلز بنكهة البصل",
    type: "وجبات خفيفة",
    serving: "علبة صغيرة",
    size: 1,
    weight: 50,
    protein: 4.05,
    fat: 16.949,
    carbohydrates: 25.75,
    calories: 265.5,
    sugar: null,
  },
  {
    food: "برنجلز بنكهة الجبن",
    type: "وجبات خفيفة",
    serving: "علبة صغيرة",
    size: 1,
    weight: 50,
    protein: 3.49,
    fat: 18.5,
    carbohydrates: 25.31,
    calories: 275.5,
    sugar: null,
  },
  {
    food: "بروكولي",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 91,
    protein: 2.6,
    fat: 0.3,
    carbohydrates: 6,
    calories: 30.9,
    sugar: 1.5,
  },
  {
    food: "برياني دجاج",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 15.38,
    fat: 2.5,
    carbohydrates: 14,
    calories: 141.2,
    sugar: null,
  },
  {
    food: "برياني لحم",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 17.99,
    fat: 2.63,
    carbohydrates: 13.05,
    calories: 142.9,
    sugar: null,
  },
  {
    food: "بسكويت بالجبن",
    type: "خبز وحبوب",
    serving: "قطعة واحدة",
    size: 1,
    weight: 1,
    protein: 0.1,
    fat: 0.25,
    carbohydrates: 0.58,
    calories: 5.03,
    sugar: null,
  },
  {
    food: "بسكويت بالقمح",
    type: "خبز وحبوب",
    serving: "قطعة واحدة",
    size: 1,
    weight: 2,
    protein: 0.17,
    fat: 0.41,
    carbohydrates: 1.3,
    calories: 9.46,
    sugar: null,
  },
  {
    food: "بسكويت مملح",
    type: "خبز وحبوب",
    serving: "قطعة واحدة",
    size: 1,
    weight: 3,
    protein: 0.22,
    fat: 0.76,
    carbohydrates: 1.83,
    calories: 15.06,
    sugar: null,
  },
  {
    food: "بصل",
    type: "خضروات",
    serving: "كوب(مفروم)",
    size: 1,
    weight: 160,
    protein: 1.8,
    fat: 0.2,
    carbohydrates: 14.9,
    calories: 64,
    sugar: 6.8,
  },
  {
    food: "بط مشوي بدون الجلد",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 20,
    fat: 9.5,
    carbohydrates: 0,
    calories: 170.8,
    sugar: 0,
  },
  {
    food: "بط مشوي مع الجلد",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 16.1,
    fat: 24.1,
    carbohydrates: 0,
    calories: 286.4,
    sugar: 0,
  },
  {
    food: "بطاطس",
    type: "خضروات",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 213,
    protein: 4.3,
    fat: 0.2,
    carbohydrates: 37.2,
    calories: 164,
    sugar: 1.7,
  },
  {
    food: "بطاطس مقلية",
    type: "أكلات شعبية",
    serving: "50 حبة",
    size: 50,
    weight: 100,
    protein: 2.8,
    fat: 5.6,
    carbohydrates: 31.4,
    calories: 187,
    sugar: null,
  },
  {
    food: "بقصمات",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 108,
    protein: 14.4,
    fat: 5.7,
    carbohydrates: 77.7,
    calories: 426.6,
    sugar: null,
  },
  {
    food: "بلاليط",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 5.5,
    fat: 6.1,
    carbohydrates: 30.4,
    calories: 199,
    sugar: null,
  },
  {
    food: "بوبر",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 33,
    protein: 0.3,
    fat: null,
    carbohydrates: 1.1,
    calories: 5,
    sugar: null,
  },
  {
    food: "بياض البيض",
    type: "بيض",
    serving: "بياض بيضة",
    size: 1,
    weight: 33,
    protein: 3.6,
    fat: 0.1,
    carbohydrates: 0.2,
    calories: 15.8,
    sugar: 0.2,
  },
  {
    food: "بيض أوز",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 144,
    protein: 20,
    fat: 19.1,
    carbohydrates: 1.9,
    calories: 266.4,
    sugar: 1.4,
  },
  {
    food: "بيض الرومي",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 79,
    protein: 10.8,
    fat: 9.4,
    carbohydrates: 0.9,
    calories: 135.1,
    sugar: null,
  },
  {
    food: "بيض السمن",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 9,
    protein: 1.2,
    fat: 1,
    carbohydrates: null,
    calories: 14.2,
    sugar: null,
  },
  {
    food: "بيض بط",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 70,
    protein: 9,
    fat: 9.6,
    carbohydrates: 1,
    calories: 129.5,
    sugar: 0.7,
  },
  {
    food: "بيض دجاج",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 50,
    protein: 6.3,
    fat: 5,
    carbohydrates: 0.4,
    calories: 71.5,
    sugar: 0.4,
  },
  {
    food: "بيض مجفف",
    type: "بيض",
    serving: "ملعقة شاي",
    size: 1,
    weight: 5,
    protein: 2.4,
    fat: 2.2,
    carbohydrates: 0.1,
    calories: 30.8,
    sugar: null,
  },
  {
    food: "بيض مخفوق مع الحليب",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 61,
    protein: 6.8,
    fat: 7.4,
    carbohydrates: 1.3,
    calories: 101.9,
    sugar: 1.1,
  },
  {
    food: "بيض مسلوق",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 50,
    protein: 6.3,
    fat: 5.3,
    carbohydrates: 0.6,
    calories: 77.5,
    sugar: 0.6,
  },
  {
    food: "بيض مقلي",
    type: "بيض",
    serving: "بيضة",
    size: 1,
    weight: 46,
    protein: 6.3,
    fat: 7,
    carbohydrates: 0.4,
    calories: 90.2,
    sugar: 0.4,
  },
  {
    food: "تبولة",
    type: "خضروات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28.35,
    protein: 1,
    fat: 2,
    carbohydrates: 2,
    calories: 30,
    sugar: null,
  },
  {
    food: "تفاح",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 138,
    protein: 0.4,
    fat: 0.2,
    carbohydrates: 19.1,
    calories: 71.8,
    sugar: 14.3,
  },
  {
    food: "تفاح مجفف",
    type: "فواكه",
    serving: "شريحة",
    size: 1,
    weight: 98,
    protein: 0.9,
    fat: 0.3,
    carbohydrates: 64.6,
    calories: 238.1,
    sugar: 56,
  },
  {
    food: "تكة لحم",
    type: "أكلات شعبية",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 35.3,
    fat: 3.9,
    carbohydrates: 1.2,
    calories: 181,
    sugar: null,
  },
  {
    food: "تمر هندي",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 120,
    protein: 3.4,
    fat: 0.7,
    carbohydrates: 75,
    calories: 286.8,
    sugar: 68.9,
  },
  {
    food: "توت",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 123,
    protein: 1.5,
    fat: 0.8,
    carbohydrates: 14.7,
    calories: 64,
    sugar: 5.4,
  },
  {
    food: "توكس",
    type: "وجبات خفيفة",
    serving: "قطعة",
    size: 1,
    weight: 57,
    protein: 3.08,
    fat: 13.4,
    carbohydrates: 37.45,
    calories: 272.46,
    sugar: null,
  },
  {
    food: "ثريد",
    type: "أكلات شعبية",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 100,
    protein: 6.8,
    fat: 3.5,
    carbohydrates: 12.1,
    calories: 107,
    sugar: null,
  },
  {
    food: "ثوم",
    type: "خضروات",
    serving: "3 فصوص",
    size: 3,
    weight: 9,
    protein: 0.6,
    fat: null,
    carbohydrates: 3,
    calories: 13.4,
    sugar: 0.1,
  },
  {
    food: "جبن بارميزان مبشور",
    type: "ألبان",
    serving: "ملعقة شاي",
    size: 1,
    weight: 5,
    protein: 1.9,
    fat: 1.4,
    carbohydrates: 0.2,
    calories: 21.6,
    sugar: null,
  },
  {
    food: "جبن تشيدر",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 7,
    fat: 9.3,
    carbohydrates: 0.4,
    calories: 112.8,
    sugar: 0.1,
  },
  {
    food: "جبن حلوم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 100,
    protein: 16.4,
    fat: 29.4,
    carbohydrates: 8.2,
    calories: 363,
    sugar: null,
  },
  {
    food: "جبن حليب الماعز جامد",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 8.5,
    fat: 10,
    carbohydrates: 0.6,
    calories: 126.6,
    sugar: 0.6,
  },
  {
    food: "جبن حليب الماعز لين",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 5.2,
    fat: 5.9,
    carbohydrates: 0.2,
    calories: 75,
    sugar: 0.2,
  },
  {
    food: "جبن حليب الماعز متوسط الليونة",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 6,
    fat: 8.4,
    carbohydrates: 0.7,
    calories: 101.9,
    sugar: 0.7,
  },
  {
    food: "جبن ريكوتا قليل الدسم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 124,
    protein: 14.1,
    fat: 9.8,
    carbohydrates: 6.4,
    calories: 171.1,
    sugar: 0.4,
  },
  {
    food: "جبن ريكوتا كامل الدسم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 124,
    protein: 14,
    fat: 16.1,
    carbohydrates: 3.8,
    calories: 215.8,
    sugar: 0.3,
  },
  {
    food: "جبن فيتا",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 4,
    fat: 6,
    carbohydrates: 1.1,
    calories: 73.9,
    sugar: 1.1,
  },
  {
    food: "جبن كريم",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 15,
    protein: 0.9,
    fat: 5.1,
    carbohydrates: 0.6,
    calories: 51.3,
    sugar: null,
  },
  {
    food: "جبن كريم خالي الدسم",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 4.4,
    fat: 0.3,
    carbohydrates: 2.1,
    calories: 29.4,
    sugar: 0.1,
  },
  {
    food: "جبن كريم قليل الدسم",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 2.2,
    fat: 4.3,
    carbohydrates: 2.3,
    calories: 56.3,
    sugar: 0.1,
  },
  {
    food: "جبن كوتج < 5% دهون",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 226,
    protein: 23.4,
    fat: 0.7,
    carbohydrates: 15.1,
    calories: 162.7,
    sugar: 4.2,
  },
  {
    food: "جبن موازاريلا كامل الدسم",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 6.2,
    fat: 6.3,
    carbohydrates: 0.6,
    calories: 84,
    sugar: 0.3,
  },
  {
    food: "جبن موزاريلا خالي الدسم",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 8.9,
    fat: 0,
    carbohydrates: 1,
    calories: 41.7,
    sugar: 0.4,
  },
  {
    food: "جبن موزاريلا قليل الدسم",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 6.8,
    fat: 4.5,
    carbohydrates: 0.8,
    calories: 71.1,
    sugar: 0.3,
  },
  {
    food: "جريب فروت",
    type: "فواكه",
    serving: "نصف واحدة متوسطة",
    size: 0.5,
    weight: 118,
    protein: 0.7,
    fat: 0.1,
    carbohydrates: 9.5,
    calories: 37.8,
    sugar: 8.2,
  },
  {
    food: "جزر",
    type: "خضروات",
    serving: "واحدة",
    size: 1,
    weight: 72,
    protein: 0.7,
    fat: 0.2,
    carbohydrates: 6.9,
    calories: 29.5,
    sugar: 3.3,
  },
  {
    food: "جزر صغير",
    type: "خضروات",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 10,
    protein: 0.1,
    fat: null,
    carbohydrates: 0.8,
    calories: 3.5,
    sugar: 0.5,
  },
  {
    food: "جلاب",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 3.1,
    fat: 25,
    carbohydrates: 24,
    calories: 333,
    sugar: null,
  },
  {
    food: "جوافة",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 90,
    protein: 2.3,
    fat: 0.9,
    carbohydrates: 12.9,
    calories: 61.2,
    sugar: 8,
  },
  {
    food: "جوز الهند",
    type: "مكسرات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 45,
    protein: 1.5,
    fat: 15.1,
    carbohydrates: 6.9,
    calories: 159.3,
    sugar: 2.8,
  },
  {
    food: "جوز الهند مجفف",
    type: "مكسرات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 1.9,
    fat: 18.1,
    carbohydrates: 6.6,
    calories: 184.8,
    sugar: 2.1,
  },
  {
    food: "حبوب الذرة",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 166,
    protein: 15.6,
    fat: 7.9,
    carbohydrates: 123.3,
    calories: 605.9,
    sugar: null,
  },
  {
    food: "حبوب القمح",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 192,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: null,
  },
  {
    food: "حسو",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 2.9,
    fat: 7.1,
    carbohydrates: 14.9,
    calories: 135,
    sugar: null,
  },
  {
    food: "حليب مبخر",
    type: "ألبان",
    serving: "6 ملاعق طعام",
    size: 6,
    weight: 100,
    protein: 7,
    fat: 7.9,
    carbohydrates: 9.7,
    calories: 137,
    sugar: null,
  },
  {
    food: "حليب الغنم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 245,
    protein: 14.7,
    fat: 17.2,
    carbohydrates: 13.1,
    calories: 264.6,
    sugar: null,
  },
  {
    food: "حليب الماعز",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 244,
    protein: 8.7,
    fat: 10.1,
    carbohydrates: 10.9,
    calories: 168.4,
    sugar: 10.9,
  },
  {
    food: "حليب بالشكولاتة",
    type: "وجبات خفيفة",
    serving: "علبة واحدة",
    size: 1,
    weight: 44,
    protein: 3.04,
    fat: 13.46,
    carbohydrates: 26.09,
    calories: 225.72,
    sugar: null,
  },
  {
    food: "حليب بالشوكولاتة قليل الدسم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 250,
    protein: 7.5,
    fat: 4.8,
    carbohydrates: 30.3,
    calories: 190,
    sugar: 23.9,
  },
  {
    food: "حليب بالفراولة",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 266,
    protein: 8,
    fat: 8.2,
    carbohydrates: 32.7,
    calories: 234.1,
    sugar: null,
  },
  {
    food: "حليب بودرة",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 32,
    protein: 8.4,
    fat: 8.5,
    carbohydrates: 12.3,
    calories: 158.7,
    sugar: 12.3,
  },
  {
    food: "حليب جوز الهند",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 240,
    protein: 5.5,
    fat: 57.2,
    carbohydrates: 13.3,
    calories: 552,
    sugar: 8,
  },
  {
    food: "حليب قليل الدسم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 244,
    protein: 8.1,
    fat: 4.8,
    carbohydrates: 11.4,
    calories: 122,
    sugar: 12.3,
  },
  {
    food: "حليب كامل الدسم",
    type: "ألبان",
    serving: "ثلث كوب",
    size: 0.3,
    weight: 100,
    protein: 3.5,
    fat: 3,
    carbohydrates: 5.5,
    calories: 64,
    sugar: null,
  },
  {
    food: "حليب مبخر معلب منزوع الدسم",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 32,
    protein: 2.4,
    fat: 0.1,
    carbohydrates: 3.6,
    calories: 25,
    sugar: 3.6,
  },
  {
    food: "حليب مكثف محلى (معلب)",
    type: "ألبان",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 38,
    protein: 3,
    fat: 3.3,
    carbohydrates: 20.7,
    calories: 122,
    sugar: 20.7,
  },
  {
    food: "حليب منزوع الدسم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 245,
    protein: 8.3,
    fat: 0.2,
    carbohydrates: 12.2,
    calories: 83.3,
    sugar: 12.5,
  },
  {
    food: "حمام",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 21.8,
    fat: 3.3,
    carbohydrates: 0,
    calories: 117.8,
    sugar: null,
  },
  {
    food: "حمام بدون الجلد",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 14.9,
    fat: 6.4,
    carbohydrates: 0,
    calories: 120.7,
    sugar: null,
  },
  {
    food: "حمام مطبوخ",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 20.3,
    fat: 11,
    carbohydrates: 0,
    calories: 186.2,
    sugar: 0,
  },
  {
    food: "حمام مقلي",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 27.8,
    fat: 4.2,
    carbohydrates: 0,
    calories: 150,
    sugar: null,
  },
  {
    food: "حمص",
    type: "خضروات",
    serving: "ملعقة طعام",
    size: 1,
    weight: 14,
    protein: 1.1,
    fat: 1.3,
    carbohydrates: 2,
    calories: 23.2,
    sugar: null,
  },
  {
    food: "خبز أبيض",
    type: "خبز وحبوب",
    serving: "ربع خبز",
    size: 0.25,
    weight: 25,
    protein: 1.9,
    fat: 0.8,
    carbohydrates: 12.7,
    calories: 66.5,
    sugar: 1.1,
  },
  {
    food: "خبز أبيض محمص",
    type: "خبز وحبوب",
    serving: "ربع خبز",
    size: 0.25,
    weight: 22,
    protein: 2,
    fat: 0.9,
    carbohydrates: 12,
    calories: 64.5,
    sugar: 1,
  },
  {
    food: "خبز أسمر",
    type: "خبز وحبوب",
    serving: "ربع خبز",
    size: 0.25,
    weight: 28,
    protein: 3.6,
    fat: 0.9,
    carbohydrates: 11.6,
    calories: 69.2,
    sugar: 1.6,
  },
  {
    food: "خبز الشوفان",
    type: "خبز وحبوب",
    serving: "شريحة صغيرة",
    size: 1,
    weight: 27,
    protein: 2.3,
    fat: 1.2,
    carbohydrates: 13.1,
    calories: 72.6,
    sugar: 0,
  },
  {
    food: "خبز الشوفان بالنخالة",
    type: "خبز وحبوب",
    serving: "شريحة صغيرة",
    size: 1,
    weight: 30,
    protein: 3.1,
    fat: 1.3,
    carbohydrates: 11.9,
    calories: 70.8,
    sugar: 0,
  },
  {
    food: "خبز بالجبن",
    type: "خبز وحبوب",
    serving: "قطعة",
    size: 1,
    weight: 66,
    protein: 4.69,
    fat: 12.08,
    carbohydrates: 28.84,
    calories: 237.6,
    sugar: null,
  },
  {
    food: "خبز بالنخالة",
    type: "خبز وحبوب",
    serving: "ربع خبز",
    size: 0.25,
    weight: 36,
    protein: 3.2,
    fat: 1.2,
    carbohydrates: 17.2,
    calories: 89.3,
    sugar: 3.5,
  },
  {
    food: "خبز رول أبيض",
    type: "خبز وحبوب",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 28,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 2.2,
  },
  {
    food: "خبز رول أسمر",
    type: "خبز وحبوب",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 36,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 0.6,
  },
  {
    food: "خبز رول البرجر",
    type: "خبز وحبوب",
    serving: "واحدة",
    size: 1,
    weight: 43,
    protein: 4.1,
    fat: 1.9,
    carbohydrates: 21.3,
    calories: 120,
    sugar: 2.3,
  },
  {
    food: "خبز فرنسي",
    type: "خبز وحبوب",
    serving: "شريحة صغيرة",
    size: 1,
    weight: 32,
    protein: 3.8,
    fat: 0.6,
    carbohydrates: 18.1,
    calories: 92.5,
    sugar: 1.1,
  },
  {
    food: "خبيصة",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 3.5,
    fat: 6.3,
    carbohydrates: 58.6,
    calories: 305,
    sugar: null,
  },
  {
    food: "خنفروش",
    type: "أكلات شعبية",
    serving: "3 حبات",
    size: 3,
    weight: 100,
    protein: 6.3,
    fat: 10.1,
    carbohydrates: 50.1,
    calories: 316,
    sugar: null,
  },
  {
    food: "خيار",
    type: "خضروات",
    serving: "حبة كبيرة",
    size: 1,
    weight: 301,
    protein: 2,
    fat: 0.3,
    carbohydrates: 10.9,
    calories: 45.2,
    sugar: 5,
  },
  {
    food: "خيار مخلل حامض",
    type: "خضروات",
    serving: "شريحة واحدة",
    size: 1,
    weight: 7,
    protein: 0.02,
    fat: 0.01,
    carbohydrates: 0.16,
    calories: 0.77,
    sugar: null,
  },
  {
    food: "دال",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 4.5,
    fat: 2.5,
    carbohydrates: 13.2,
    calories: 93,
    sugar: null,
  },
  {
    food: "دجاج",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 18.2,
    fat: 2.6,
    carbohydrates: 0,
    calories: 101.2,
    sugar: 0,
  },
  {
    food: "دجاج معلب",
    type: "لحوم",
    serving: "علبة",
    size: 1,
    weight: 142,
    protein: 30.9,
    fat: 11.3,
    carbohydrates: 0,
    calories: 234.3,
    sugar: 0,
  },
  {
    food: "دقيق الشوفان",
    type: "خبز وحبوب",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 3.6,
    fat: 1.8,
    carbohydrates: 18.9,
    calories: 105,
    sugar: null,
  },
  {
    food: "دقيق الشوفان مطهي",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 234,
    protein: 5.5,
    fat: 3.2,
    carbohydrates: 27.3,
    calories: 159.1,
    sugar: null,
  },
  {
    food: "ذرة طازج",
    type: "خضروات",
    serving: "نصف كوب",
    size: 0.5,
    weight: 140,
    protein: 3.68,
    fat: 1.02,
    carbohydrates: 39.07,
    calories: 176.4,
    sugar: null,
  },
  {
    food: "ذرة محلى ومعلب",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 164,
    protein: 4.3,
    fat: 1.64,
    carbohydrates: 30.49,
    calories: 132.84,
    sugar: null,
  },
  {
    food: "ربيان",
    type: "لحوم",
    serving: "5 حبات",
    size: 5,
    weight: 100,
    protein: 19.7,
    fat: 0.8,
    carbohydrates: 0,
    calories: 87.1,
    sugar: null,
  },
  {
    food: "ربيان مقلي",
    type: "لحوم",
    serving: "3 حبات متوسطة",
    size: 3,
    weight: 85,
    protein: 18.17,
    fat: 10.43,
    carbohydrates: 9.74,
    calories: 205.71,
    sugar: null,
  },
  {
    food: "رقائق الذرة ( المحلاة )",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 38,
    protein: 2.014,
    fat: 0.532,
    carbohydrates: 34.24,
    calories: 148.58,
    sugar: null,
  },
  {
    food: "رقائق الذرة العادي",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 28,
    protein: 1.84,
    fat: 0.199,
    carbohydrates: 24.22,
    calories: 102.2,
    sugar: null,
  },
  {
    food: "روب",
    type: "ألبان",
    serving: "ثلث كوب",
    size: 0.3,
    weight: 100,
    protein: 3.2,
    fat: 2.6,
    carbohydrates: 5.4,
    calories: 59,
    sugar: null,
  },
  {
    food: "روب قليل الدسم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 227,
    protein: 11.9,
    fat: 3.5,
    carbohydrates: 16,
    calories: 143,
    sugar: 16,
  },
  {
    food: "روب قليل الدسم بالفانيلا",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 227,
    protein: 11.2,
    fat: 2.8,
    carbohydrates: 31.3,
    calories: 193,
    sugar: 31.3,
  },
  {
    food: "روب قليل الدسم بالفراولة",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 227,
    protein: 9,
    fat: 2.6,
    carbohydrates: 42.3,
    calories: 224.7,
    sugar: 42.3,
  },
  {
    food: "روب منزوع الدسم",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 227,
    protein: 13,
    fat: 0.4,
    carbohydrates: 17.4,
    calories: 127.1,
    sugar: 17.4,
  },
  {
    food: "روب منزوع الدسم بالشوكولاتة",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 227,
    protein: 8,
    fat: 0,
    carbohydrates: 53.4,
    calories: 245.2,
    sugar: 34,
  },
  {
    food: "روب منزوع الدسم بالفواكه",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 227,
    protein: 10,
    fat: 0.5,
    carbohydrates: 43.1,
    calories: 215.6,
    sugar: 43.1,
  },
  {
    food: "زبدة المارجرين ( بدون ملح )",
    type: "دهون",
    serving: "ملعقة صغيرة",
    size: 1,
    weight: 4.7,
    protein: 0.02,
    fat: 3.77,
    carbohydrates: 0.02,
    calories: 33.56,
    sugar: null,
  },
  {
    food: "زبدة مارجرين ( مملحة )",
    type: "دهون",
    serving: "ملعقة صغيرة",
    size: 1,
    weight: 4.7,
    protein: 0.04,
    fat: 3.78,
    carbohydrates: 0.04,
    calories: 33.78,
    sugar: null,
  },
  {
    food: "زيت الذرة",
    type: "دهون",
    serving: "ملعقة صغيرة",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "زيت الزيتون",
    type: "دهون",
    serving: "ملعقة صغيرة",
    size: 1,
    weight: 13.51,
    protein: 0,
    fat: 13.51,
    carbohydrates: 0,
    calories: 119.44,
    sugar: null,
  },
  {
    food: "زيت النخيل",
    type: "دهون",
    serving: "ملعقة صغيرة",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "زيت دوار الشمس",
    type: "دهون",
    serving: "ملعقة صغيرة",
    size: 1,
    weight: 13.64,
    protein: 0,
    fat: 13.64,
    carbohydrates: 0,
    calories: 120.55,
    sugar: null,
  },
  {
    food: "زيتون معلب",
    type: "خضروات",
    serving: "حبة",
    size: 1,
    weight: 8.3,
    protein: 0.08,
    fat: 0.57,
    carbohydrates: 0.47,
    calories: 6.72,
    sugar: null,
  },
  {
    food: "ساكو",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 1,
    fat: 2.2,
    carbohydrates: 25.5,
    calories: 126,
    sugar: null,
  },
  {
    food: "سجق",
    type: "لحوم",
    serving: "قطعة",
    size: 1,
    weight: 57,
    protein: 6.84,
    fat: 16.25,
    carbohydrates: 1.03,
    calories: 179.55,
    sugar: null,
  },
  {
    food: "سكر أبيض",
    type: "خبز وحبوب",
    serving: "ملعقة شاي",
    size: 1,
    weight: 4,
    protein: 0,
    fat: 0,
    carbohydrates: 3.99,
    calories: 15.48,
    sugar: null,
  },
  {
    food: "سكر أسمر",
    type: "خبز وحبوب",
    serving: "ملعقة شاي",
    size: 1,
    weight: 3,
    protein: 0,
    fat: 0,
    carbohydrates: 2.92,
    calories: 11.28,
    sugar: null,
  },
  {
    food: "سلطة خضروات",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 100,
    protein: 0.93,
    fat: 1.86,
    carbohydrates: 4.51,
    calories: 39.59,
    sugar: null,
  },
  {
    food: "سلمون معلب",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 17.4,
    fat: 6.21,
    carbohydrates: 0,
    calories: 130,
    sugar: null,
  },
  {
    food: "سمان مطبوخ",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 21.3,
    fat: 12,
    carbohydrates: 0,
    calories: 198.9,
    sugar: 0,
  },
  {
    food: "سمبوسة جبن",
    type: "أكلات شعبية",
    serving: "3 حبات",
    size: 3,
    weight: 100,
    protein: 10.4,
    fat: 19.8,
    carbohydrates: 49.7,
    calories: 418.4,
    sugar: null,
  },
  {
    food: "سمبوسة خضرة",
    type: "أكلات شعبية",
    serving: "4 حبات",
    size: 4,
    weight: 100,
    protein: 5.07,
    fat: 13.61,
    carbohydrates: 33.29,
    calories: 275,
    sugar: null,
  },
  {
    food: "سمك الحمراء",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 22.37,
    fat: 1.45,
    carbohydrates: 0,
    calories: 108.81,
    sugar: null,
  },
  {
    food: "سمك تونا معلب",
    type: "لحوم",
    serving: "بحجم راحة اليد",
    size: 1,
    weight: 85,
    protein: 21.68,
    fat: 0.69,
    carbohydrates: 0,
    calories: 98.61,
    sugar: null,
  },
  {
    food: "سمك مقلي",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 23.7,
    fat: 13,
    carbohydrates: null,
    calories: 211,
    sugar: null,
  },
  {
    food: "سنكرس",
    type: "وجبات خفيفة",
    serving: "قطعة",
    size: 1,
    weight: 61,
    protein: 5.86,
    fat: 13.6,
    carbohydrates: 36.78,
    calories: 277.55,
    sugar: null,
  },
  {
    food: "شاي بدون سكر",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 236,
    protein: 0,
    fat: 0,
    carbohydrates: 0.06,
    calories: 0.3,
    sugar: null,
  },
  {
    food: "شاي مثلج (Ice Tea)",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 236.6,
    protein: 0,
    fat: 0,
    carbohydrates: 28.59,
    calories: 118.3,
    sugar: null,
  },
  {
    food: "شاي مع سكر",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 236,
    protein: 0.03,
    fat: 0,
    carbohydrates: 2.75,
    calories: 11.01,
    sugar: null,
  },
  {
    food: "شبس برنجلز عادي",
    type: "وجبات خفيفة",
    serving: "علبة صغيرة",
    size: 1,
    weight: 50,
    protein: 2.95,
    fat: 19.21,
    carbohydrates: 25.5,
    calories: 278.99,
    sugar: null,
  },
  {
    food: "شبس بنكهة الجبن",
    type: "وجبات خفيفة",
    serving: "كيس صغير",
    size: 1,
    weight: 25,
    protein: 2.125,
    fat: 6.8,
    carbohydrates: 14.43,
    calories: 124,
    sugar: null,
  },
  {
    food: "شبس عادي غير مملح",
    type: "وجبات خفيفة",
    serving: "كيس صغير",
    size: 1,
    weight: 25,
    protein: 1.6,
    fat: 8.84,
    carbohydrates: 12.96,
    calories: 130.75,
    sugar: null,
  },
  {
    food: "شبس عادي مملح",
    type: "وجبات خفيفة",
    serving: "كيس صغير",
    size: 1,
    weight: 25,
    protein: 1.75,
    fat: 8.66,
    carbohydrates: 13.23,
    calories: 134,
    sugar: null,
  },
  {
    food: "شبس منفوش ( مينو )",
    type: "وجبات خفيفة",
    serving: "كيس صغير",
    size: 1,
    weight: 25,
    protein: 1.682,
    fat: 9.525,
    carbohydrates: 12.889,
    calories: 137.94,
    sugar: null,
  },
  {
    food: "شراب برتقال",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 247.79,
    protein: 0,
    fat: 0,
    carbohydrates: 31.96,
    calories: 126.37,
    sugar: null,
  },
  {
    food: "شراب بنكهة الفواكه",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 192,
    protein: 2.11,
    fat: 3.84,
    carbohydrates: 58.37,
    calories: 264.96,
    sugar: null,
  },
  {
    food: "شراب عنب",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 250.18,
    protein: 0,
    fat: 0,
    carbohydrates: 28.77,
    calories: 112.58,
    sugar: null,
  },
  {
    food: "شراب ليمون",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 266,
    protein: 0,
    fat: 0,
    carbohydrates: 28.73,
    calories: 11172,
    sugar: null,
  },
  {
    food: "شعري",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 19.7,
    fat: 1.1,
    carbohydrates: 0,
    calories: 89.8,
    sugar: null,
  },
  {
    food: "شعري مقلي",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 25.9,
    fat: 7,
    carbohydrates: 0,
    calories: 167,
    sugar: null,
  },
  {
    food: "شمندر",
    type: "خضروات",
    serving: "شرائح(نصف كوب)",
    size: 0.5,
    weight: 68,
    protein: 1.1,
    fat: 0.1,
    carbohydrates: 6.5,
    calories: 29.2,
    sugar: 4.6,
  },
  {
    food: "شوارما الدجاج",
    type: "أكلات شعبية",
    serving: "واحدة",
    size: 1,
    weight: 100,
    protein: 20.6,
    fat: 5.2,
    carbohydrates: 23.9,
    calories: 224.9,
    sugar: null,
  },
  {
    food: "شوارما اللحم",
    type: "أكلات شعبية",
    serving: "واحدة",
    size: 1,
    weight: 100,
    protein: 20,
    fat: 6.4,
    carbohydrates: 22.2,
    calories: 227.2,
    sugar: null,
  },
  {
    food: "شوفان كويكر",
    type: "خبز وحبوب",
    serving: "ملعقتين ونصف",
    size: 2.5,
    weight: 40,
    protein: 6.8,
    fat: 3.2,
    carbohydrates: 25.2,
    calories: 145.6,
    sugar: null,
  },
  {
    food: "شوفان كويكر محضر بالماء",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 234,
    protein: 4.8,
    fat: 2.2,
    carbohydrates: 17.5,
    calories: 100.6,
    sugar: null,
  },
  {
    food: "شوفان مطبوخ",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 219,
    protein: 7,
    fat: 1.9,
    carbohydrates: 25.1,
    calories: 87.6,
    sugar: null,
  },
  {
    food: "شيبس الموز",
    type: "وجبات خفيفة",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 0.6,
    fat: 9.4,
    carbohydrates: 16.4,
    calories: 145.3,
    sugar: 9.9,
  },
  {
    food: "صافي",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 18.9,
    fat: 7.3,
    carbohydrates: 0.1,
    calories: 141.8,
    sugar: null,
  },
  {
    food: "صافي مشوي",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 27.3,
    fat: 4.3,
    carbohydrates: 0,
    calories: 148.9,
    sugar: null,
  },
  {
    food: "صدر دجاج بروستد",
    type: "لحوم",
    serving: "½ صدر دجاجة صغيرة",
    size: 0.5,
    weight: 85,
    protein: 26.35,
    fat: 3,
    carbohydrates: 0,
    calories: 140.26,
    sugar: null,
  },
  {
    food: "صدر دجاج مقلي",
    type: "لحوم",
    serving: "½ صدر دجاجة صغيرة",
    size: 0.5,
    weight: 85,
    protein: 28.42,
    fat: 4,
    carbohydrates: 0.42,
    calories: 158.94,
    sugar: null,
  },
  {
    food: "صفار بيض",
    type: "بيض",
    serving: "صفار بيضة واحدة",
    size: 1,
    weight: 17,
    protein: 2.7,
    fat: 4.5,
    carbohydrates: 0.6,
    calories: 53.9,
    sugar: 0.1,
  },
  {
    food: "طحين ابيض",
    type: "خبز وحبوب",
    serving: "كوب واحد",
    size: 1,
    weight: 125,
    protein: 12.19,
    fat: 1.23,
    carbohydrates: 95.39,
    calories: 455,
    sugar: null,
  },
  {
    food: "طحين الذرة",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 114,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 0.2,
  },
  {
    food: "طحين رز أبيض",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 158,
    protein: 9.4,
    fat: 2.2,
    carbohydrates: 126.6,
    calories: 578.3,
    sugar: null,
  },
  {
    food: "طحين رز أسمر",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 158,
    protein: 11.4,
    fat: 4.4,
    carbohydrates: 120.8,
    calories: 573.5,
    sugar: 0.5,
  },
  {
    food: "طحين قمح أسمر",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 120,
    protein: 16.4,
    fat: 2.2,
    carbohydrates: 87.1,
    calories: 406.8,
    sugar: 6.7,
  },
  {
    food: "طعمية",
    type: "خضروات",
    serving: "حبة واحدة",
    size: 1,
    weight: 17,
    protein: 2.3,
    fat: 3,
    carbohydrates: 5.4,
    calories: 56.6,
    sugar: null,
  },
  {
    food: "طماطم",
    type: "خضروات",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 123,
    protein: 1.1,
    fat: 0.2,
    carbohydrates: 4.8,
    calories: 22.1,
    sugar: 3.2,
  },
  {
    food: "عدس",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 198,
    protein: 17.9,
    fat: 0.8,
    carbohydrates: 39.9,
    calories: 229.7,
    sugar: 3.6,
  },
  {
    food: "عسل",
    type: "خبز وحبوب",
    serving: "ملعقة طعام",
    size: 1,
    weight: 21,
    protein: 0.06,
    fat: 0,
    carbohydrates: 17.3,
    calories: 63.84,
    sugar: null,
  },
  {
    food: "عصيدة",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 4.3,
    fat: 11.9,
    carbohydrates: 29.6,
    calories: 243,
    sugar: null,
  },
  {
    food: "عصير أناناس",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 250.17,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 34.48,
    calories: 140.11,
    sugar: null,
  },
  {
    food: "عصير برتقال",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 248,
    protein: 1.74,
    fat: 0.5,
    carbohydrates: 25.79,
    calories: 111.6,
    sugar: null,
  },
  {
    food: "عصير برتقال مع المشمش",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 249.39,
    protein: 0.75,
    fat: 0.25,
    carbohydrates: 31.67,
    calories: 127.19,
    sugar: null,
  },
  {
    food: "عصير تفاح غير محلى",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 247.79,
    protein: 0.15,
    fat: 0.27,
    carbohydrates: 28.94,
    calories: 116.46,
    sugar: null,
  },
  {
    food: "عصير جريب فروت (غيرمحلى)",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 246.99,
    protein: 1.28,
    fat: 0.25,
    carbohydrates: 22.13,
    calories: 93.86,
    sugar: null,
  },
  {
    food: "عصير جريب فروت (محلى)",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 249.39,
    protein: 1.45,
    fat: 0.22,
    carbohydrates: 27.76,
    calories: 114.72,
    sugar: null,
  },
  {
    food: "عصير جزر",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 246,
    protein: 2.34,
    fat: 0.37,
    carbohydrates: 22.88,
    calories: 98.4,
    sugar: null,
  },
  {
    food: "عصير جوافة",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 239.91,
    protein: 0,
    fat: 0,
    carbohydrates: 21.63,
    calories: 87.86,
    sugar: null,
  },
  {
    food: "عصير طماطم",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 244,
    protein: 1.8,
    fat: 0.15,
    carbohydrates: 10.32,
    calories: 41.48,
    sugar: null,
  },
  {
    food: "عصير فواكه مشكلة",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 255,
    protein: 0.99,
    fat: 0.18,
    carbohydrates: 48.22,
    calories: 186.15,
    sugar: null,
  },
  {
    food: "عصير كمثرى",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 255.78,
    protein: 1.56,
    fat: 0.08,
    carbohydrates: 44.63,
    calories: 181.61,
    sugar: null,
  },
  {
    food: "عصير مانجو",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 239.91,
    protein: 0,
    fat: 0,
    carbohydrates: 21.63,
    calories: 87.86,
    sugar: null,
  },
  {
    food: "عصير مشمش",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 258,
    protein: 1.23,
    fat: 0.23,
    carbohydrates: 55.34,
    calories: 214.14,
    sugar: null,
  },
  {
    food: "عقيلي",
    type: "أكلات شعبية",
    serving: "شريحة",
    size: 1,
    weight: 100,
    protein: 10.1,
    fat: 9.4,
    carbohydrates: 56.7,
    calories: 352,
    sugar: null,
  },
  {
    food: "عيش شيلاني",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 3.1,
    fat: 3.8,
    carbohydrates: 31.3,
    calories: 172,
    sugar: null,
  },
  {
    food: "غوج",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 66,
    protein: 0.5,
    fat: 0.2,
    carbohydrates: 7.5,
    calories: 30.4,
    sugar: 6.5,
  },
  {
    food: "غوزي دجاج",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 10.11,
    fat: 3.3,
    carbohydrates: 22.68,
    calories: 160.8,
    sugar: null,
  },
  {
    food: "غوزي لحم",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 11.4,
    fat: 3.4,
    carbohydrates: 22.4,
    calories: 166.9,
    sugar: null,
  },
  {
    food: "فاصوليا بيضاء",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 179,
    protein: 17.4,
    fat: 0.6,
    carbohydrates: 44.9,
    calories: 248.8,
    sugar: 0.6,
  },
  {
    food: "فاصولياء صفراء",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 177,
    protein: 16.2,
    fat: 1.9,
    carbohydrates: 44.7,
    calories: 254.9,
    sugar: null,
  },
  {
    food: "فالودة",
    type: "أكلات شعبية",
    serving: "ثلثين كوب",
    size: 0.67,
    weight: 100,
    protein: 0.9,
    fat: 0.9,
    carbohydrates: 18.4,
    calories: 85,
    sugar: null,
  },
  {
    food: "فخد دجاج مقلي",
    type: "لحوم",
    serving: "فخد دجاجة متوسطة",
    size: 1,
    weight: 85,
    protein: 18.5,
    fat: 13.73,
    carbohydrates: 7.41,
    calories: 232,
    sugar: null,
  },
  {
    food: "فخذ دجاج بروستد",
    type: "لحوم",
    serving: "فخد دجاجة متوسطة",
    size: 1,
    weight: 85,
    protein: 22,
    fat: 11.45,
    carbohydrates: 0,
    calories: 197.19,
    sugar: null,
  },
  {
    food: "فخذ دجاج مقلي",
    type: "لحوم",
    serving: "فخد دجاجة متوسطة",
    size: 1,
    weight: 85,
    protein: 18.5,
    fat: 13.73,
    carbohydrates: 7.41,
    calories: 232,
    sugar: null,
  },
  {
    food: "فراولة",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 144,
    protein: 1,
    fat: 0.4,
    carbohydrates: 11.1,
    calories: 46.1,
    sugar: 6.7,
  },
  {
    food: "فستق مجفف",
    type: "مكسرات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 5.8,
    fat: 12.4,
    carbohydrates: 7.8,
    calories: 156,
    sugar: 2.9,
  },
  {
    food: "فستق مجفف محمص",
    type: "مكسرات",
    serving: "ملعقتين طعام (47 حبة)",
    size: 2,
    weight: 28,
    protein: 6,
    fat: 12.9,
    carbohydrates: 7.7,
    calories: 159.9,
    sugar: 2.9,
  },
  {
    food: "فلفل أحمر حار",
    type: "خضروات",
    serving: "حبة",
    size: 1,
    weight: 45,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 4,
    calories: 18,
    sugar: 2.4,
  },
  {
    food: "فلفل أخضر حار",
    type: "خضروات",
    serving: "حبة",
    size: 1,
    weight: 45,
    protein: 0.9,
    fat: 0.1,
    carbohydrates: 4.3,
    calories: 18,
    sugar: 2.3,
  },
  {
    food: "فول الصويا",
    type: "مكسرات",
    serving: "كوب",
    size: 1,
    weight: 172,
    protein: 28.6,
    fat: 15.4,
    carbohydrates: 17.1,
    calories: 297.6,
    sugar: 5.2,
  },
  {
    food: "فول الصويا محمص",
    type: "مكسرات",
    serving: "كوب",
    size: 1,
    weight: 172,
    protein: 60.6,
    fat: 43.7,
    carbohydrates: 57.7,
    calories: 810.1,
    sugar: 30.4,
  },
  {
    food: "فول الصويا محمص مجفف",
    type: "مكسرات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 11.1,
    fat: 6.1,
    carbohydrates: 9.2,
    calories: 126.3,
    sugar: 2.3,
  },
  {
    food: "قرص طابي",
    type: "أكلات شعبية",
    serving: "4 قطع",
    size: 4,
    weight: 100,
    protein: 6.7,
    fat: 18.9,
    carbohydrates: 36.9,
    calories: 345,
    sugar: null,
  },
  {
    food: "قرقفان",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 19.9,
    fat: 3.7,
    carbohydrates: 0.4,
    calories: 115,
    sugar: null,
  },
  {
    food: "قرقفان مشوي",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 22.8,
    fat: 1.8,
    carbohydrates: 0,
    calories: 108.6,
    sugar: null,
  },
  {
    food: "قشر البرتقال",
    type: "فواكه",
    serving: "ملعقة شاي",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: null,
    carbohydrates: 1.5,
    calories: 5.8,
    sugar: null,
  },
  {
    food: "قشر الليمون",
    type: "فواكه",
    serving: "ملعقة شاي",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: null,
    carbohydrates: 1,
    calories: 2.8,
    sugar: 0.3,
  },
  {
    food: "قطع الخبز المحمص",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 30,
    protein: 3.6,
    fat: 2,
    carbohydrates: 22,
    calories: 122.1,
    sugar: null,
  },
  {
    food: "قلقاس",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 104,
    protein: 1.6,
    fat: 0.2,
    carbohydrates: 27.5,
    calories: 116.5,
    sugar: 0.4,
  },
  {
    food: "قهوة جاهزة",
    type: "مشروبات",
    serving: "كوب ونصف",
    size: 1.5,
    weight: 29.86,
    protein: 0.03,
    fat: 0,
    carbohydrates: 0.12,
    calories: 0.6,
    sugar: null,
  },
  {
    food: "قهوة كبتشينو",
    type: "مشروبات",
    serving: "كوب ونصف",
    size: 1.5,
    weight: 29.3,
    protein: 0.06,
    fat: 0.32,
    carbohydrates: 1.64,
    calories: 9.38,
    sugar: null,
  },
  {
    food: "قيمة",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 7.5,
    fat: 4.5,
    carbohydrates: 7.4,
    calories: 100,
    sugar: null,
  },
  {
    food: "كاري الدجاج",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 9.7,
    fat: 1.5,
    carbohydrates: 8,
    calories: 84.7,
    sugar: null,
  },
  {
    food: "كاري السمك",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 13,
    fat: 2,
    carbohydrates: 3.8,
    calories: 86.6,
    sugar: null,
  },
  {
    food: "كاري اللحم",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 15.3,
    fat: 2.8,
    carbohydrates: 3,
    calories: 99.4,
    sugar: null,
  },
  {
    food: "كاستر",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 2.8,
    fat: 3.1,
    carbohydrates: 12.6,
    calories: 90,
    sugar: null,
  },
  {
    food: "كباب",
    type: "أكلات شعبية",
    serving: "4 حبات",
    size: 4,
    weight: 100,
    protein: 8.1,
    fat: 12.6,
    carbohydrates: 33.7,
    calories: 281,
    sugar: null,
  },
  {
    food: "كباب لحم",
    type: "أكلات شعبية",
    serving: "بحجم الكف (قطع)",
    size: 1,
    weight: 100,
    protein: 25.16,
    fat: 12.96,
    carbohydrates: 1.55,
    calories: 223,
    sugar: null,
  },
  {
    food: "كبد دجاج",
    type: "لحوم",
    serving: "3 قطع متوسطة",
    size: 3,
    weight: 85,
    protein: 20.72,
    fat: 4.65,
    carbohydrates: 0.75,
    calories: 133.5,
    sugar: null,
  },
  {
    food: "كبدة لحم مطبوخة",
    type: "لحوم",
    serving: "4 قطع متوسطة",
    size: 4,
    weight: 85,
    protein: 22.73,
    fat: 6.81,
    carbohydrates: 6.67,
    calories: 184.45,
    sugar: null,
  },
  {
    food: "كراث (بقل)",
    type: "خضروات",
    serving: "صرة (كوب)",
    size: 1,
    weight: 89,
    protein: 1.3,
    fat: 0.3,
    carbohydrates: 12.6,
    calories: 54.3,
    sugar: 3.5,
  },
  {
    food: "كرفس",
    type: "خضروات",
    serving: "حبة متوسطة الحجم",
    size: 1,
    weight: 40,
    protein: 0.3,
    fat: 0.1,
    carbohydrates: 1.2,
    calories: 6.4,
    sugar: 0.7,
  },
  {
    food: "كروسون بالجبن",
    type: "خبز وحبوب",
    serving: "قطعة متوسطة",
    size: 1,
    weight: 57,
    protein: 5.24,
    fat: 11.91,
    carbohydrates: 26.79,
    calories: 235.98,
    sugar: null,
  },
  {
    food: "كروسون بالزبدة",
    type: "خبز وحبوب",
    serving: "قطعة متوسطة",
    size: 1,
    weight: 57,
    protein: 4.67,
    fat: 11.97,
    carbohydrates: 26.11,
    calories: 231.42,
    sugar: null,
  },
  {
    food: "كريم مبيض القهوة (خفيف)",
    type: "كريمات",
    serving: "ملعقة طعام",
    size: 1,
    weight: 15,
    protein: 0.4,
    fat: 2.9,
    carbohydrates: 0.5,
    calories: 29.2,
    sugar: null,
  },
  {
    food: "كريمة بودرة",
    type: "كريمات",
    serving: "ملعقة طعام",
    size: 1,
    weight: 6,
    protein: 0.3,
    fat: 2.1,
    carbohydrates: 3.3,
    calories: 32.7,
    sugar: 3.3,
  },
  {
    food: "كريمة بودرة قليلة الدسم",
    type: "كريمات",
    serving: "ملعقة طعام",
    size: 1,
    weight: 6,
    protein: 0.1,
    fat: 0.9,
    carbohydrates: 4.4,
    calories: 25.9,
    sugar: 4.4,
  },
  {
    food: "كريمة حامضة خالية الدهن",
    type: "كريمات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 30,
    protein: 0.9,
    fat: 0,
    carbohydrates: 4.7,
    calories: 22.2,
    sugar: 0.1,
  },
  {
    food: "كريمة حامضة قليلة الدهن",
    type: "كريمات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 30,
    protein: 2.1,
    fat: 4.2,
    carbohydrates: 2.1,
    calories: 54.3,
    sugar: 0.1,
  },
  {
    food: "كريمة سائلة (خفيفة)",
    type: "كريمات",
    serving: "ملعقة طعام",
    size: 1,
    weight: 30,
    protein: 0.2,
    fat: 1,
    carbohydrates: 2.7,
    calories: 21.3,
    sugar: 2.7,
  },
  {
    food: "كمثرى",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 166,
    protein: 0.6,
    fat: 0.2,
    carbohydrates: 25.7,
    calories: 96.3,
    sugar: 16.3,
  },
  {
    food: "كمثرى مجفف",
    type: "فواكه",
    serving: "10 أنصاف",
    size: 10,
    weight: 175,
    protein: 3.3,
    fat: 1.1,
    carbohydrates: 122,
    calories: 458.5,
    sugar: 108.8,
  },
  {
    food: "كنعد",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 19.5,
    fat: 9.3,
    carbohydrates: 0,
    calories: 161,
    sugar: null,
  },
  {
    food: "كنعد مقلي",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 26.7,
    fat: 11.9,
    carbohydrates: 0,
    calories: 213.7,
    sugar: null,
  },
  {
    food: "كولا (دايت)",
    type: "مشروبات",
    serving: "كوب ونصف",
    size: 1.5,
    weight: 369,
    protein: 0.2,
    fat: 0,
    carbohydrates: 0.3,
    calories: 2,
    sugar: null,
  },
  {
    food: "كولا (عادي)",
    type: "مشروبات",
    serving: "كوب ونصف",
    size: 1.5,
    weight: 369,
    protein: 0.1,
    fat: 0.1,
    carbohydrates: 38.5,
    calories: 151,
    sugar: null,
  },
  {
    food: "كيت كات",
    type: "وجبات خفيفة",
    serving: "قطعة واحدة",
    size: 1,
    weight: 46,
    protein: 3.08,
    fat: 13.11,
    carbohydrates: 28.47,
    calories: 234.6,
    sugar: null,
  },
  {
    food: "كيك عادي (مافين)",
    type: "خبز وحبوب",
    serving: "حجم كبير",
    size: 1,
    weight: 65,
    protein: 4.49,
    fat: 7.41,
    carbohydrates: 26.91,
    calories: 192.4,
    sugar: null,
  },
  {
    food: "كينوا",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 170,
    protein: 24,
    fat: 10.3,
    carbohydrates: 109.1,
    calories: 625.6,
    sugar: null,
  },
  {
    food: "كيوي",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 76,
    protein: 0.9,
    fat: 0.4,
    carbohydrates: 11.1,
    calories: 46.4,
    sugar: 6.8,
  },
  {
    food: "لبنة",
    type: "ألبان",
    serving: "كوب",
    size: 1,
    weight: 100,
    protein: 12.9,
    fat: 10.8,
    carbohydrates: 1,
    calories: 154,
    sugar: null,
  },
  {
    food: "لحم بقر مسلوق (مطحون)",
    type: "لحوم",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 85,
    protein: 20.45,
    fat: 17.6,
    carbohydrates: 0,
    calories: 245.65,
    sugar: null,
  },
  {
    food: "لحم بقر مقلي (مطحون)",
    type: "لحوم",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 85,
    protein: 20.33,
    fat: 19.2,
    carbohydrates: 0,
    calories: 260,
    sugar: null,
  },
  {
    food: "لحم عجل مطبوخ",
    type: "لحوم",
    serving: "3 قطع صغيرة",
    size: 3,
    weight: 85,
    protein: 23.99,
    fat: 8,
    carbohydrates: 0,
    calories: 175,
    sugar: null,
  },
  {
    food: "لقيمات",
    type: "أكلات شعبية",
    serving: "5 حبات",
    size: 5,
    weight: 100,
    protein: 3,
    fat: 9.5,
    carbohydrates: 44.4,
    calories: 275,
    sugar: null,
  },
  {
    food: "لوز (بيذان)",
    type: "مكسرات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 5.9,
    fat: 13.8,
    carbohydrates: 6.1,
    calories: 161,
    sugar: 1.3,
  },
  {
    food: "ليمون",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 58,
    protein: 0.6,
    fat: 0.2,
    carbohydrates: 5.4,
    calories: 16.8,
    sugar: 1.4,
  },
  {
    food: "ليمون صودا",
    type: "مشروبات",
    serving: "كوب ونصف",
    size: 1.5,
    weight: 355,
    protein: 0,
    fat: 0,
    carbohydrates: 38.4,
    calories: 149,
    sugar: null,
  },
  {
    food: "ماء جوز الهند",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 240,
    protein: 1.7,
    fat: 0.5,
    carbohydrates: 8.9,
    calories: 45.6,
    sugar: 6.3,
  },
  {
    food: "مانجو",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 207,
    protein: 1.1,
    fat: 0.6,
    carbohydrates: 35.2,
    calories: 134.6,
    sugar: 30.6,
  },
  {
    food: "مايونيز",
    type: "دهون",
    serving: "ملعقة صغيرة",
    size: 1,
    weight: 14.7,
    protein: 0.13,
    fat: 4.91,
    carbohydrates: 3.51,
    calories: 57.29,
    sugar: null,
  },
  {
    food: "مجبوس دجاج",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 17,
    fat: 2.39,
    carbohydrates: 17.2,
    calories: 158.36,
    sugar: null,
  },
  {
    food: "مجبوس لحم",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 16.89,
    fat: 3,
    carbohydrates: 16.87,
    calories: 166.5,
    sugar: null,
  },
  {
    food: "محشي كوسا",
    type: "أكلات شعبية",
    serving: "حبة",
    size: 1,
    weight: 100,
    protein: 4.86,
    fat: 1.51,
    carbohydrates: 14.67,
    calories: 86.37,
    sugar: null,
  },
  {
    food: "محشي ورق عنب",
    type: "أكلات شعبية",
    serving: "4 حبات",
    size: 4,
    weight: 100,
    protein: 7.47,
    fat: 2.73,
    carbohydrates: 16.11,
    calories: 125.2,
    sugar: null,
  },
  {
    food: "محلبية",
    type: "أكلات شعبية",
    serving: "ثلثين كوب",
    size: 0.67,
    weight: 100,
    protein: 2.9,
    fat: 2.9,
    carbohydrates: 17.6,
    calories: 108,
    sugar: null,
  },
  {
    food: "مرق سمك",
    type: "أكلات شعبية",
    serving: "نصف",
    size: 0.5,
    weight: 100,
    protein: 7,
    fat: 5.8,
    carbohydrates: 0.5,
    calories: 82,
    sugar: null,
  },
  {
    food: "مشروم",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 70,
    protein: 2.2,
    fat: 0.2,
    carbohydrates: 2.3,
    calories: 15.4,
    sugar: 1.2,
  },
  {
    food: "مشمش",
    type: "فواكه",
    serving: "3 حبات",
    size: 3,
    weight: 105,
    protein: 1.5,
    fat: 0.4,
    carbohydrates: 11.7,
    calories: 50.4,
    sugar: 9.7,
  },
  {
    food: "مشمش مجفف",
    type: "فواكه",
    serving: "كوب",
    size: 1,
    weight: 65,
    protein: 2.2,
    fat: 0.3,
    carbohydrates: 40.7,
    calories: 156.6,
    sugar: 34.7,
  },
  {
    food: "مضروبة",
    type: "أكلات شعبية",
    serving: "نصف",
    size: 0.5,
    weight: 100,
    protein: 8.55,
    fat: 0.9,
    carbohydrates: 5.34,
    calories: 63.6,
    sugar: null,
  },
  {
    food: "معجون طماطم",
    type: "خضروات",
    serving: "168 جرام (علبة)",
    size: 1,
    weight: 170,
    protein: 7.3,
    fat: 0.8,
    carbohydrates: 32.1,
    calories: 139.4,
    sugar: 17.7,
  },
  {
    food: "معكرونة الدجاج",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 17.9,
    fat: 1.9,
    carbohydrates: 10,
    calories: 129.7,
    sugar: null,
  },
  {
    food: "معكرونة مطبوخة",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 140,
    protein: 6.68,
    fat: 0.94,
    carbohydrates: 39.68,
    calories: 197.4,
    sugar: null,
  },
  {
    food: "مكسرات الذرة",
    type: "مكسرات",
    serving: "ملعقتين طعام",
    size: 2,
    weight: 28,
    protein: 2.4,
    fat: 4.4,
    carbohydrates: 20.1,
    calories: 124.9,
    sugar: 0.2,
  },
  {
    food: "مكسرات مشكلة محمصة",
    type: "مكسرات",
    serving: "1/8 كوب",
    size: 0.125,
    weight: 28,
    protein: 4.8,
    fat: 14.4,
    carbohydrates: 7.1,
    calories: 166.3,
    sugar: 2.5,
  },
  {
    food: "مكسرات مشكلة محمصة بالزيت",
    type: "مكسرات",
    serving: "1/8 كوب",
    size: 0.125,
    weight: 28,
    protein: 4.7,
    fat: 15.8,
    carbohydrates: 6,
    calories: 172.8,
    sugar: 2.8,
  },
  {
    food: "مندي دجاج",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 14.6,
    fat: 2.3,
    carbohydrates: 17.9,
    calories: 154.9,
    sugar: null,
  },
  {
    food: "مندي لحم",
    type: "أكلات شعبية",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 11.9,
    fat: 1.9,
    carbohydrates: 20.34,
    calories: 147,
    sugar: null,
  },
  {
    food: "موز",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 118,
    protein: 1.3,
    fat: 0.4,
    carbohydrates: 27,
    calories: 105,
    sugar: 14.4,
  },
  {
    food: "ميد",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 18.3,
    fat: 16.1,
    carbohydrates: 0,
    calories: 216.7,
    sugar: null,
  },
  {
    food: "ميد مشوي",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 24.2,
    fat: 10.5,
    carbohydrates: 0,
    calories: 191.2,
    sugar: null,
  },
  {
    food: "نخالة الذرة",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 76,
    protein: 6.4,
    fat: 0.7,
    carbohydrates: 65.1,
    calories: 170.2,
    sugar: 0.2,
  },
  {
    food: "نخالة الرز",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 118,
    protein: 15.8,
    fat: 24.6,
    carbohydrates: 58.6,
    calories: 372.9,
    sugar: 5.4,
  },
  {
    food: "نخالة القمح",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 58,
    protein: 9,
    fat: 2.5,
    carbohydrates: 37.4,
    calories: 125.3,
    sugar: 2.7,
  },
  {
    food: "نفيش",
    type: "وجبات خفيفة",
    serving: "كوب",
    size: 1,
    weight: 11,
    protein: 0.99,
    fat: 3.09,
    carbohydrates: 6.29,
    calories: 55,
    sugar: null,
  },
  {
    food: "نكتار الأجاص (كمثرى)",
    type: "مشروبات",
    serving: "كوب",
    size: 1,
    weight: 248.59,
    protein: 0.67,
    fat: 0.05,
    carbohydrates: 34.6,
    calories: 134.24,
    sugar: null,
  },
  {
    food: "نكتار مشمش",
    type: "مشروبات",
    serving: "ثلاثة أرباع الكوب",
    size: 0.75,
    weight: 250.99,
    protein: 0.93,
    fat: 0.23,
    carbohydrates: 36.12,
    calories: 140.55,
    sugar: null,
  },
  {
    food: "نكتارين",
    type: "فواكه",
    serving: "واحدة متوسطة",
    size: 1,
    weight: 136,
    protein: 1.4,
    fat: 0.4,
    carbohydrates: 14.3,
    calories: 59.8,
    sugar: 10.7,
  },
  {
    food: "نودلز مطبوخة",
    type: "خبز وحبوب",
    serving: "كوب",
    size: 1,
    weight: 160,
    protein: 7.6,
    fat: 2.35,
    carbohydrates: 39.74,
    calories: 212.8,
    sugar: null,
  },
  {
    food: "هامور",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 19.3,
    fat: 3.4,
    carbohydrates: 0.2,
    calories: 109.3,
    sugar: null,
  },
  {
    food: "هامور مع الرز",
    type: "لحوم",
    serving: "نصف كوب",
    size: 0.5,
    weight: 100,
    protein: 27.3,
    fat: 3.2,
    carbohydrates: 0,
    calories: 139.2,
    sugar: null,
  },
  {
    food: "هريس",
    type: "أكلات شعبية",
    serving: "ربع كوب",
    size: 0.25,
    weight: 100,
    protein: 9,
    fat: 0.7,
    carbohydrates: 8.3,
    calories: 76,
    sugar: null,
  },
  {
    food: "هليون",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 134,
    protein: 2.9,
    fat: 0.2,
    carbohydrates: 5.2,
    calories: 26.8,
    sugar: 2.5,
  },
  {
    food: "ورق العنب",
    type: "خضروات",
    serving: "كوب",
    size: 1,
    weight: 14,
    protein: 0.8,
    fat: 0.3,
    carbohydrates: 2.4,
    calories: 13,
    sugar: 0.9,
  },
  {
    food: "ينم",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 17.9,
    fat: 10.4,
    carbohydrates: 0,
    calories: 164.7,
    sugar: null,
  },
  {
    food: "ينم مشوي",
    type: "لحوم",
    serving: "بحجم الكف",
    size: 1,
    weight: 100,
    protein: 25.9,
    fat: 5.6,
    carbohydrates: 0,
    calories: 154.8,
    sugar: null,
  },
];
export default foodData;
